


































import * as _ from "lodash";

/**
 * See https://github.com/DCsunset/vuetify-markdown-editor
 */
import {Editor} from "vuetify-markdown-editor";
import "vuetify-markdown-editor/dist/vuetify-markdown-editor.css";

import {Component, Prop, Vue} from "vue-property-decorator";

@Component({
    components: {Editor}
})
export default class ReminderForm extends Vue {
    text: string = null;
    valid: boolean = false;
    nameRules: any = [
        v => !!v || "Name is required",
        v => v && v.length <= 30 || "Name must be less than 30 characters.",
    ];
    email: string = "";
    emailRules: any = [
        v => !!v || "E-mail is required",
        v => /.+@.+/.test(v) || "E-mail must be valid",
    ];

    get name() {
        return this.$store.state.selectedModel ?
            this.$store.state.selectedModel.name :
            null;
    }

    set name(value) {
        this.$store.dispatch("updateProperty", {propertyName: "name", value: value});
    }

    get content() {
        return this.$store.state.selectedModel ?
            this.$store.state.selectedModel.content :
            null;
    }

    set content(value) {
        this.$store.dispatch("updateProperty", {propertyName: "content", value: value});
    }

    onSubmit(e) {
        return false;
    }

    onInputEnter() {

        return false;
    }

    mounted() {
        (this.$refs.editor as any).focus();
    }
}

